import { render, staticRenderFns } from "./prjSelectRefPropertyDialog.vue?vue&type=template&id=32d4a6b6"
import script from "./prjSelectRefPropertyDialog.vue?vue&type=script&lang=js"
export * from "./prjSelectRefPropertyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports